import { useTranslation } from 'react-i18next';

import { SelectV2 } from '@pukka/ui-components';

const LANG_OPTIONS = [
  {
    key: 'id',
    value: 'Bahasa Indonesia',
  },
  {
    key: 'en',
    value: 'English',
  },
];

function LanguagePicker() {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (value: string) => {
    i18n.changeLanguage(value);
  };

  const selectedLang = LANG_OPTIONS.find((option) => option.key === i18n.language);

  return (
    <div className="w-[170px] text-black" data-testid="language-picker">
      <SelectV2 key="lang" size="s" value={selectedLang} options={LANG_OPTIONS} onChange={handleChangeLanguage} />
    </div>
  );
}

export { LanguagePicker };
